import { useSyncExternalStore } from 'react';

/** matchMedia 가 없는 환경(jsdom 기본값 등)에선 null — 던지지 않고 "안 맞음" 으로 읽게 한다. */
function mediaQueryList(query: string): MediaQueryList | null {
  return typeof window.matchMedia === 'function' ? window.matchMedia(query) : null;
}

/**
 * Reactive hook for CSS media queries.
 * Returns true when the query matches, false otherwise.
 * Falls back to false during SSR / initial render, and where matchMedia is unavailable.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (callback) => {
      const mql = mediaQueryList(query);
      mql?.addEventListener('change', callback);
      return () => mql?.removeEventListener('change', callback);
    },
    () => mediaQueryList(query)?.matches ?? false,
    () => false
  );
}
